import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { updateProfile } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db } from '../../services/firebase';
import { FiCamera, FiSave } from 'react-icons/fi';
import toast from 'react-hot-toast';

const InstructorSettings = () => {
    const { user } = useAuth();
    const [displayName, setDisplayName] = useState(user?.displayName || '');
    const [photoURL, setPhotoURL] = useState(user?.photoURL || '');
    const [uploading, setUploading] = useState(false);
    const [saving, setSaving] = useState(false);

    const handlePhotoUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setUploading(true);
        try {
            const storage = getStorage();
            const storageRef = ref(storage, `users/${user.uid}/profile.jpg`);
            await uploadBytes(storageRef, file);
            const url = await getDownloadURL(storageRef);
            setPhotoURL(url);
            toast.success('Foto subida');
        } catch { toast.error('Error al subir foto'); }
        setUploading(false);
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await updateProfile(user, { displayName, photoURL });
            await setDoc(doc(db, 'users', user.uid), { displayName, photoURL, updatedAt: new Date() }, { merge: true });
            toast.success('Perfil actualizado');
        } catch { toast.error('Error al guardar'); }
        setSaving(false);
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-start justify-center pt-12 px-4">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-200 w-full max-w-md p-8">
                <h1 className="text-xl font-bold text-gray-900 mb-1">Mi Perfil</h1>
                <p className="text-sm text-gray-500 mb-6">Actualiza tu información personal.</p>

                {/* Avatar */}
                <div className="flex items-center gap-4 mb-6">
                    <div className="relative">
                        {photoURL ? (
                            <img src={photoURL} alt="" className="w-20 h-20 rounded-full object-cover ring-2 ring-gray-200" />
                        ) : (
                            <div className="w-20 h-20 rounded-full bg-blue-500 flex items-center justify-center text-2xl font-bold text-white">
                                {displayName?.charAt(0)?.toUpperCase() || 'U'}
                            </div>
                        )}
                        <label className="absolute -bottom-1 -right-1 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition shadow-lg">
                            <FiCamera size={14} className="text-white" />
                            <input type="file" className="hidden" accept="image/*" onChange={handlePhotoUpload} disabled={uploading} />
                        </label>
                    </div>
                    <div>
                        <p className="text-sm font-medium text-gray-800">{uploading ? 'Subiendo...' : 'Haz clic en el icono para cambiar foto'}</p>
                        <p className="text-xs text-gray-400">{user?.email}</p>
                    </div>
                </div>

                {/* Name */}
                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nombre</label>
                    <input type="text" value={displayName} onChange={e => setDisplayName(e.target.value)}
                        className="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none text-sm" />
                </div>

                {/* Email (read-only) */}
                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input type="email" value={user?.email || ''} disabled
                        className="w-full px-4 py-2.5 border border-gray-100 rounded-xl bg-gray-50 text-sm text-gray-500 cursor-not-allowed" />
                </div>

                <button onClick={handleSave} disabled={saving}
                    className="w-full py-2.5 bg-blue-600 text-white rounded-xl font-medium hover:bg-blue-700 disabled:opacity-50 flex items-center justify-center gap-2 transition">
                    {saving ? <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> : <FiSave size={16} />}
                    Guardar cambios
                </button>
            </div>
        </div>
    );
};

export default InstructorSettings;
